export default __webpack_public_path__ + "static/media/bag.037bc38b.svg";